/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tall_Fast_Snail_SpotInputs */

const en_tall_fast_snail_spot = /** @type {(inputs: Tall_Fast_Snail_SpotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select at least one peer-feedback data source to create entries per feedback group.`)
};

const de_tall_fast_snail_spot = /** @type {(inputs: Tall_Fast_Snail_SpotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wähle mindestens eine Peer-Feedback-Datenquelle aus, um pro Feedback-Gruppe Einträge zu erstellen.`)
};

/**
* | output |
* | --- |
* | "Select at least one peer-feedback data source to create entries per feedback group." |
*
* @param {Tall_Fast_Snail_SpotInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tall_fast_snail_spot = /** @type {((inputs?: Tall_Fast_Snail_SpotInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tall_Fast_Snail_SpotInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tall_fast_snail_spot(inputs)
	return de_tall_fast_snail_spot(inputs)
});